import Loader from '@amzn/meridian/loader';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';

interface LoadingProps {
  message?: string;
}

function Loading({ message }: LoadingProps) {
  return (
    <Column alignmentHorizontal="center" alignmentVertical="center" minHeight="50vh" spacingInset="600" spacing="300">
      <Loader size="large" label={message || 'Loading'} />
      {message && <Text type="b200">{message}</Text>}
    </Column>
  );
}

export default Loading;
